import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";

export function useLocations() {
  return useQuery({
    queryKey: ["locations", "NZ"],
    queryFn: async () => {
      const { data } = await sharedApi.get("/classifieds/locations", { params: { country: "NZ" } });
      return data.regions || [];
    },
    staleTime: 10 * 60_000,
  });
}
